import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    pwaRegionLabel,
    pwaRegionSwitcherOptions,
    pwaRegionWalkHint,
    pwaRegionWalkHref,
} from './ordersSurface';
import type { PwaRegionOption } from './ordersSurface';

type Props = {
    regionId: string;
    search?: string;
    jobStatus?: string;
};

const RegionWalkSwitcher = ({ regionId, search = '', jobStatus }: Props) => {
    const history = useHistory();
    const options: PwaRegionOption[] = pwaRegionSwitcherOptions(regionId);
    const regionLabel = pwaRegionLabel(regionId, options);
    return (
        <label className="pwa-region-switcher" data-testid="pwa-region-switcher">
            Region
            <select
                aria-label="PWA jobs region"
                value={regionId}
                onChange={(event) => {
                    const next = event.target.value;
                    if (!next || next === regionId) return;
                    history.push(pwaRegionWalkHref(next, search, jobStatus));
                }}
            >
                {options.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.label} · {option.id}
                    </option>
                ))}
            </select>
            <small>{pwaRegionWalkHint(regionLabel, regionId)}</small>
        </label>
    );
};

export default RegionWalkSwitcher;
